module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_17_2.b886227c.jpeg";